const constants = {
    num_buttons: 12,
    num_actions: 3,
    action_sysex_size: 7,
    //Button Action	Action	Data 1	Data 2	Data 3	Data 4	Data 5
    defaultSysex : [7,127,127,127,127,127,0]
};

export default constants